import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN, MIDDLE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerWrap: {
      [theme.breakpoints.up('md')]: {
        borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
        paddingBottom: MIDDLE_MARGIN,
        marginBottom: MIDDLE_MARGIN,
      },
    },
    titleWrap: {
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    fullWidthContainer: {
      width: '100%',
    },
    contentWrap: {
      [theme.breakpoints.down('sm')]: {
        padding: '0 24px',
      },
    },
    icon: {
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    btn: {
      marginTop: MIDDLE_MARGIN,
      width: 150,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    wrapper: {
      '&:last-child': {
        marginBottom: MIDDLE_MARGIN,
      },
      [theme.breakpoints.down('sm')]: {
        '&:not(:last-child)': {
          borderBottom: 'none',
          marginBottom: SMALL_MARGIN,
        },
      },
    },
  }),
);

export default useStyles;
